import { AxiosInstance, AxiosPromise } from 'axios'

import { GetAddressRequest, GetAddressResponse } from './type'

export const getAddress = async (
  instance: AxiosInstance,
  params: GetAddressRequest
): AxiosPromise<GetAddressResponse> => {
  return await instance.get('/zipApi/api/search', { params, baseURL: '' })
}
